export const blogPosts = [
    {
        id: "cool",
        notionID: "dc6dfef0945341358627210a5c622db9"
    }
]